import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getPlanProgressPS: ['plan', 'prog'],
  getPlanProgressPSRequest: null,
  getPlanProgressPSSuccess: null,
  getPlanProgressPSFailure: ['error'],
  getPlanProgressPSClear: null
});
export { Creators, Types };
